import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Evaluate2 from '../views/Evaluate2.vue'
import EvaluateAI from '../views/EvaluateAI.vue'
import Settings from '../views/Settings.vue'
import AdminPanel from '../views/AdminPanel.vue'
import ConfirmEmail from '../views/ConfirmEmail.vue'
import Queue from '../views/Queue.vue'
import Review2 from '../views/Review2.vue'
import Forbidden from '../views/403.vue'
import Maintenance from '../views/503.vue'
import RevEnrInfo from '../views/ReviewerEnrollment/RevEnrInfo.vue'
import RevEnrStep1 from '../views/ReviewerEnrollment/RevEnrStep1.vue'
import RevEnrStep2 from '../views/ReviewerEnrollment/RevEnrStep2.vue'
import RevEnrStep3 from '../views/ReviewerEnrollment/RevEnrStep3.vue'
import NotFound from '../views/404.vue'
import MyReviews from '../views/MyReviews.vue'
import MyReviewsAI from '../views/MyReviewsAI.vue'
import ReviewStatus from '../views/ReviewStatus.vue'
import AiReviewStatus from '../views/ReviewStatusAI.vue'
import RevProfile from '../views/ReviewerProfile.vue'
import RevDashboard from '../views/ReviewerDashboard.vue'
import Logout from '../views/Logout.vue'
import Legal from '../views/Legal.vue'
import PasswordReset from '../views/PasswordReset.vue'
import GoPro from '../views/GoPro.vue'
import ProPanel from '../views/ProPanel.vue'
import RecruitmentProcess from '../views/RecruitmentProcess.vue'
import HowToOptimizeYourResume from '../views/KnowledgeArticles/HowToOptimizeYourResume.vue'
import TheImportanceOfTailoringYourResume from '../views/KnowledgeArticles/TheImportanceOfTailoringYourResume.vue'
import CommonResumeMistakesToAvoid from '../views/KnowledgeArticles/CommonResumeMistakesToAvoid.vue'
import FaangResumeGuide from '../views/KnowledgeArticles/FaangResumeGuide.vue'
import GoogleResumeGuide from '../views/KnowledgeArticles/GoogleResumeGuide.vue'
import MetaResumeGuide from '../views/KnowledgeArticles/MetaResumeGuide.vue'
import AmazonResumeGuide from '../views/KnowledgeArticles/AmazonResumeGuide.vue'
import TechStartupResumeGuide from '../views/KnowledgeArticles/TechStartupResumeGuide.vue'
import DisplayResume from '../views/DisplayReviewFile.vue'
import StripeReturn from '../views/Stripe/ReturnUrl.vue'
import Support from '../views/Support.vue'
import Contact from '../views/Contact.vue'
// import Tball from '../views/Tball.vue'
import store from '../store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'FaangIT.com - AI & Expert Resume Review for Tech Jobs',
      description: 'Get your resume reviewed by AI or by engineers who work at top tech companies. Beat the applicant tracking system and land more interviews.'
    }
  },
  {
    path: '/evaluate',
    name: 'evaluate',
    component: Evaluate2,
    beforeEnter: (to, from, next) => {
      adminDevGuard(to, from, next);
    },
    meta: {
      title: 'Get Your Resume Reviewed by a Tech Professional | FaangIT.com',
      description: 'Submit your resume for a detailed review from an experienced tech industry professional and get actionable feedback to improve your chances.'
    }
  },
  {
    path: '/evaluate-ai',
    name: 'evaluate-ai',
    component: EvaluateAI,
    meta: {
      title: 'Free AI Resume Review | FaangIT.com',
      description: 'Check your resume against an AI-powered review built for tech job applications and get instant feedback on how to improve it.'
    }
  },
  {
    path: '/review',
    name: 'review',
    component: Review2,
    beforeEnter: (to, from, next) => {
      adminDevGuard(to, from, next);
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/panel',
    name: 'panel',
    component: AdminPanel,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/queue',
    name: 'queue',
    component: Queue,
    beforeEnter: (to, from, next) => {
      adminDevGuard(to, from, next);
    }
  },
  {
    path: '/confirm-email',
    name: 'confirm-email',
    component: ConfirmEmail
  },
  {
    path: '/403',
    name: '403',
    component: Forbidden
  },
  {
    path: '/503',
    name: '503',
    component: Maintenance
  },
  {
    path: '/reviewer-enrollment/info',
    name: 'reviewer-enrollment-info',
    component: RevEnrInfo,
    meta: {
      title: 'Become a Reviewer | FaangIT.com',
      description: 'Join FaangIT.com as a reviewer and help candidates land jobs at top tech companies while earning extra income.'
    }
  },
  {
    path: '/reviewer-enrollment/step1',
    name: 'reviewer-enrollment-step1',
    component: RevEnrStep1,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/reviewer-enrollment/step2',
    name: 'reviewer-enrollment-step2',
    component: RevEnrStep2,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/reviewer-enrollment/step3',
    name: 'reviewer-enrollment-step3',
    component: RevEnrStep3,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/reviewer-dashboard',
    name: 'reviewer-dashboard',
    component: RevDashboard,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/rev-profile',
    name: 'revprofile',
    component: RevProfile,
  },
  {
    path: '/myreviews',
    name: 'myreviews',
    component: MyReviews,
    beforeEnter: (to, from, next) => {
      adminDevGuard(to, from, next);
    }
  },
  {
    path: '/myreviews-ai',
    name: 'myreviews-ai',
    component: MyReviewsAI,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/review-status',
    name: 'review-status',
    component: ReviewStatus,
    beforeEnter: (to, from, next) => {
      adminDevGuard(to, from, next);
    }
  },
  {
    path: '/review-status-ai',
    name: 'review-status-ai',
    component: AiReviewStatus,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutUs.vue'),
    meta: {
      title: 'About Us | FaangIT.com',
      description: 'FaangIT.com helps professionals create outstanding resumes tailored for top tech companies, with tools, tips, and expert reviews.'
    }
  },
  {
    path: '/legal',
    name: 'legal',
    component: Legal,
    meta: {
      title: 'Terms & Privacy Policy | FaangIT.com',
      description: 'Read the terms of service and privacy policy for FaangIT.com.'
    }
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: PasswordReset,
  },
  {
    path: '/gopro',
    name: 'gopro',
    component: GoPro,
    meta: {
      title: 'Go Pro | FaangIT.com',
      description: 'Unlock exclusive features and benefits with a FaangIT.com PRO plan.'
    }
  },
  {
    path: '/proPanel',
    name: 'proPanel',
    component: ProPanel,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/recruitment-process',
    name: 'recruitment-process',
    component: RecruitmentProcess,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/how-to-optimize-your-resume',
    name: 'how-to-optimize-your-resume',
    component: HowToOptimizeYourResume,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/the-importance-of-tailoring-your-resume',
    name: 'the-importance-of-tailoring-your-resume',
    component: TheImportanceOfTailoringYourResume,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/common-resume-mistakes-to-avoid',
    name: 'common-resume-mistakes-to-avoid',
    component: CommonResumeMistakesToAvoid,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/displayresume',
    name: 'displayresume',
    component: DisplayResume,
    beforeEnter: (to, from, next) => {
      guard(to, from, next);
    }
  },
  {
    path: '/faang-resume-guide',
    name: 'faang-resume-guide',
    component: FaangResumeGuide,
    meta: {
      title: 'FAANG Resume Guide: How to Get Noticed by Top Tech Companies | FaangIT.com',
      description: 'Learn how to write a resume that gets past ATS filters and impresses recruiters at Google, Amazon, Meta, Apple, and Netflix.',
      articleHeadline: 'FAANG Resume Guide: How to Get Noticed by Google, Amazon, Meta, Apple & Netflix',
      articleDatePublished: '2026-08-20'
    }
  },
  {
    path: '/google-resume-guide',
    name: 'google-resume-guide',
    component: GoogleResumeGuide,
    meta: {
      title: 'Google Resume Guide: How to Write a Resume Google Recruiters Notice | FaangIT.com',
      description: 'Tips for writing a Google resume, including Google\'s own XYZ bullet-point formula, scope, and how hiring committees evaluate candidates.',
      articleHeadline: 'Google Resume Guide: How to Write a Resume Google Recruiters Notice',
      articleDatePublished: '2026-08-20'
    }
  },
  {
    path: '/meta-resume-guide',
    name: 'meta-resume-guide',
    component: MetaResumeGuide,
    meta: {
      title: 'Meta Resume Guide: How to Stand Out for Facebook, Instagram & WhatsApp Roles | FaangIT.com',
      description: 'How to write a resume for Meta roles, with an emphasis on measurable impact, speed, autonomy, and cross-functional work.',
      articleHeadline: 'Meta Resume Guide: How to Stand Out for Facebook, Instagram & WhatsApp Roles',
      articleDatePublished: '2026-08-20'
    }
  },
  {
    path: '/amazon-resume-guide',
    name: 'amazon-resume-guide',
    component: AmazonResumeGuide,
    meta: {
      title: 'Amazon Resume Guide: Write a Resume That Reflects the Leadership Principles | FaangIT.com',
      description: 'How to write an Amazon resume that demonstrates the Leadership Principles like Ownership, Bias for Action, and Deliver Results.',
      articleHeadline: 'Amazon Resume Guide: How to Write a Resume That Reflects the Leadership Principles',
      articleDatePublished: '2026-08-20'
    }
  },
  {
    path: '/tech-startup-resume-guide',
    name: 'tech-startup-resume-guide',
    component: TechStartupResumeGuide,
    meta: {
      title: 'Tech Startup Resume Guide: Stand Out Without a Big-Name Employer | FaangIT.com',
      description: 'How to write a resume for tech startups, with an emphasis on range, ownership, ambiguity, and direct business impact.',
      articleHeadline: 'Tech Startup Resume Guide: How to Stand Out Without a Big-Name Employer',
      articleDatePublished: '2026-08-20'
    }
  },
  {
    path: '/paymentReturn',
    name: 'paymentReturn',
    component: StripeReturn,
  },
  {
    path: '/support',
    name: 'support',
    component: Support,
    meta: {
      title: 'Support & FAQ | FaangIT.com',
      description: 'Find answers to common questions about FaangIT.com resume reviews, or contact us for help.'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      title: 'Contact Us | FaangIT.com',
      description: 'Get in touch with the FaangIT.com team.'
    }
  },
  // {
  //   path: '/tball',
  //   name: 'tball',
  //   component: Tball
  // },
  // Catch-all route for 404 Not Found
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: NotFound,
  }
  

]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
})

const guard = function(to, from, next) {
  if(store.getters.userLoggedIn) {
    next();
  } else {
    next({ name: 'login' })
  }
};

// Manual review is still being rebuilt - only admins/devs can reach it for now.
const adminDevGuard = function(to, from, next) {
  if (!store.getters.userLoggedIn) {
    next({ name: 'login' });
  } else if (store.getters.isAdmin || store.getters.isDev) {
    next();
  } else {
    next({ name: '403' });
  }
};

const DEFAULT_TITLE = 'FaangIT.com - AI & Expert Resume Review for Tech Jobs'
const DEFAULT_DESCRIPTION = 'Get your resume reviewed by AI or by engineers who work at top tech companies. Beat the applicant tracking system and land more interviews.'

router.afterEach((to) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', 'G-7KF4K76WWN', {
      page_path: to.fullPath,
      page_title: (to.meta && to.meta.title) || DEFAULT_TITLE
    })
  }

  document.title = (to.meta && to.meta.title) || DEFAULT_TITLE

  let descriptionTag = document.querySelector('meta[name="description"]')
  if (!descriptionTag) {
    descriptionTag = document.createElement('meta')
    descriptionTag.setAttribute('name', 'description')
    document.head.appendChild(descriptionTag)
  }
  descriptionTag.setAttribute('content', (to.meta && to.meta.description) || DEFAULT_DESCRIPTION)

  let canonicalTag = document.querySelector('link[rel="canonical"]')
  if (!canonicalTag) {
    canonicalTag = document.createElement('link')
    canonicalTag.setAttribute('rel', 'canonical')
    document.head.appendChild(canonicalTag)
  }
  canonicalTag.setAttribute('href', `https://faangit.com${to.path}`)

  let articleSchemaTag = document.querySelector('script[data-seo="article-schema"]')
  if (articleSchemaTag) {
    articleSchemaTag.remove()
  }
  if (to.meta && to.meta.articleHeadline) {
    articleSchemaTag = document.createElement('script')
    articleSchemaTag.type = 'application/ld+json'
    articleSchemaTag.setAttribute('data-seo', 'article-schema')
    articleSchemaTag.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: to.meta.articleHeadline,
      description: to.meta.description || DEFAULT_DESCRIPTION,
      datePublished: to.meta.articleDatePublished,
      dateModified: to.meta.articleDatePublished,
      author: { '@type': 'Organization', name: 'FaangIT.com' },
      publisher: {
        '@type': 'Organization',
        name: 'FaangIT.com',
        logo: { '@type': 'ImageObject', url: 'https://faangit.com/logo_b_full.png' }
      },
      mainEntityOfPage: { '@type': 'WebPage', '@id': `https://faangit.com${to.path}` }
    })
    document.head.appendChild(articleSchemaTag)
  }
})

export default router
